<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Add new language</h6>
            </div>
            <div class="card-body">
                <div v-if="saveMessage !== ''" class="alert alert-primary alert-dismissible fade show" role="alert">
                    {{saveMessage}}
                    <button @click="clearSaveMessage" type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div id="form">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-lg">Language name</span>
                        </div>
                        <input class="form-control" v-model="longTitle" type="text">
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-lg">Language code</span>
                        </div>
                       <input class="form-control" v-model="title" type="text">
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-lg">Flag image</span>
                        </div>
                        <b-form-file accept="image/png" v-model="flagImage"></b-form-file>
                    </div>
                    <button v-if="title !== '' && longTitle !== '' && flagImage !== null" @click="uploadImage" class="btn btn-primary">Add</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: '',
            longTitle: '',
            flagImage: null,
            saveMessage: ''
        }
    },
    methods: {
        formatCode : function(value){
            this.title = value.toUpperCase().replace(/(\W|\d|_)/, '').substring(0, 2)
        },
        clearSaveMessage: function(){
            this.saveMessage = ''
        },
        uploadImage: function(){
            let self = this
            let flag = this.flagImage
            let image = new FormData()
            image.set('flag', flag, this.title)
            this.$http.post('/api/languages/upload-flag', image)
            .then(response => {
                self.addLanguage()
            })
            .catch(error => {
                self.saveMessage = 'Language could not be added'
                console.log(error)
            })
        },
        addLanguage: function(){
            let self = this
            this.$http.post('/api/languages/add', {
                "Title": self.title,
                "LongTitle": self.longTitle
            })
            .then(response => {
                 self.saveMessage = 'Language added!'
            })
            .catch(error => {
                console.log(error)
            })
        }
    },
    watch: {
        title: function(value){
            this.formatCode(value)
        },
        longTitle: function(value){
            this.longTitle = value.charAt(0).toUpperCase() + value.substring(1).toLowerCase()
        }
    }
}
</script>

<style lang="scss" scoped>
    div{
        span.input-group-text {
            width: 145px;
        }
    }
</style>

